<div>
    <div class="note-div">
    <p> Sub LOB cannot be deleted since it has 
        <a class="app-underline" style="cursor: pointer;" (click)="navigateToPortfolio()">{{deletedRow.appCount}}</a> Applications associated with it. Select a Sub LOB from below to move the Applications to before proceeding with delete.</p>
    </div>
    <div class="row" style="margin-top: 2%">
        <div class="col-md-4 col-sm-12 col-lg-4 col-xl-4 col-xs-4">
        <span class="form-inline-new">
            <p class="merge-headers" style="color: #013b71;font-weight: bold;">Segment</p>
        </span>
        <mat-form-field [floatLabel]="'never'" class="delete-custom-dropdown">
            <mat-select [placeholder]="selectedSegment? selectedSegment.MasterSegment : 'Select Segment'"
            (selectionChange)="getLobList()" [(ngModel)]="selectedSegment" panelClass="delete-lob-dropdowns">

            <mat-option class="dropDownList" *ngFor="let segment of segmentList" [value]="segment">
                <ng-container >
                {{segment.MasterSegment}}
                </ng-container>
            </mat-option>

            </mat-select>
        </mat-form-field>
        </div>
        <div class="col-md-4 col-sm-12 col-lg-4 col-xl-4 col-xs-4">
            <span class="form-inline-new">
                <p class="merge-headers" style="color: #013b71;font-weight: bold;">LOB</p>
            </span>
            <mat-form-field [floatLabel]="'never'" class="delete-custom-dropdown">
                
                <mat-select [placeholder]="selectedLob? selectedLob.CIOLOB : 'Select Lob'"
                (selectionChange)="getSubLobList()" [(ngModel)]="selectedLob" panelClass="delete-lob-dropdowns">
                <input matinput class="mat-input-search delete-sub-lob-search" placeholder="Search" (keyup)="search('lob')"
                [(ngModel)]="searchTxt" (blur)="resetValue()"/>
                <mat-option class="dropDownList" *ngFor="let lob of lobList" [value]="lob">
                    <ng-container >
                    {{lob.CIOLOB}}
                    </ng-container>
                </mat-option>
    
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-md-4 col-sm-12 col-lg-4 col-xl-4 col-xs-4">
            <span class="form-inline-new">
                <p class="merge-headers" style="color: #013b71;font-weight: bold;">Sub LOB</p>
            </span>
            <mat-form-field [floatLabel]="'never'" class="delete-custom-dropdown">
                
                <mat-select [placeholder]="selectedSubLob? selectedSubLob.SubLineofBusiness : 'Select Sub LOB'"
                (selectionChange)="onSubLobChange()" [(ngModel)]="selectedSubLob" panelClass="delete-lob-dropdowns">
                <input matinput class="mat-input-search delete-sub-lob-search" placeholder="Search" (keyup)="search('sublob')"
                [(ngModel)]="searchTxtsub"
               />
                <mat-option class="dropDownList" *ngFor="let sublob of subLobList" [value]="sublob">
                    <ng-container >
                    {{sublob.SubLineofBusiness}}
                    </ng-container>
                </mat-option>
    
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class=" col-md-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12" style="margin-top:2%;">
            <button [disabled]="disableSubmit" (click)="submit()"   mat-mdc-raised-button 
                class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs pull-right">
                Apply
            </button>
        </div>
    </div>
</div>
<div class="stk-table-loader delete-loader" *ngIf="showLoader">
    <app-loader>
    </app-loader>
</div>
